import { useGET } from '../shared/hooks/useGET';

const toUrl = gameId => `/stats/game/${gameId}/lineup`;
export function useGameExplorerStats(gameId) {
  const url = toUrl(gameId);
  const data = useGET(url);
  return data;
}
